import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigurationService } from "./../services/configuration.service"
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

export interface RESPONSE {
  errorCode: string;
  errorDescription:string,
  Data: any
}

@Injectable({
  providedIn: 'root'
})
export class ApiRequestsService {
  public token: string = '';
  public NO_ERROR = "000000";
  private baseURL:string = "";
  constructor(
    private config: ConfigurationService, private HttpClient: HttpClient, private route: Router) {
    this.baseURL = this.config.getBaseUrl();
  }

  generateHeaderForAPIRequest = () => {
    return new HttpHeaders({ 'authorization': 'Bearer ' + this.token, "authfor": "W", });
  }


  private getApiCall = (url: string, params: any = null) => {
    let httpHeaders = this.generateHeaderForAPIRequest();
    let httpParams = new HttpParams();
    if (params)
      httpParams = httpParams.append("criteria", params);
    return this.HttpClient.get(this.baseURL + url, { params: httpParams, headers: httpHeaders }).pipe(map((data: any) => {
      // ele.style.display="none";
      if (data["errorDescription"] && (data["errorDescription"].includes('Invalid token.') || data["errorDescription"].includes('Invalid user identifier'))) {
        console.log("Invalid token.");
        this.logout();
      }
      return data;
    }));
  }

  private postApiCall = (url: string, params: any,checkToken:boolean=true) => {
   
    const ele: any = document.getElementById('loader-div');
    if (ele)
      ele.style.display = "block";
    const body: any = {};
    if (!params['criteria']) body['criteria'] = params;
    else body['criteria'] = params['criteria'];
    let httpHeaders = this.generateHeaderForAPIRequest();
    return this.HttpClient.post(this.baseURL + url, body, { headers: httpHeaders }).pipe(map((data: any) => {
      if (ele)
        ele.style.display = "none";
      if (checkToken && data["errorDescription"] && data["errorDescription"].includes('Invalid token.')) {
        console.log("Invalid token.");
        this.logout();
      }
      return data;
    }));
  }

  postApiCallReturningPromise = (url: string, body: object) => {
    return new Promise<RESPONSE>((resolve, reject) => {
      this.postApiCall(url, body).subscribe(res => {
        resolve(res);
      }, err => {
        reject(err);
      });

    })
  }
 
  getAPICallReturningPromise = (url:string, body:string) => {
    return new Promise<RESPONSE> ((resolve, reject) => {
      this.getApiCall(url, body).subscribe(res => {
        resolve(res);
      }, err => {
        reject(err);
      });

    })
  }

  getAPICallReturningPromiseWithoutbody = (url:string) => {
    return new Promise<RESPONSE> ((resolve, reject) => {
      this.getApiCall(url).subscribe(res => {
        resolve(res);
      }, err => {
        reject(err);
      });

    })
  }

  updateOrSetTokenValue = (newToken: string) => {
    this.token = newToken;
  }

  uploadFile(file: any, endPoint: string, criteria = {}) {
    const fd = new FormData();
    fd.append('criteria', JSON.stringify(criteria));
    fd.append('file', file, file.name);
    console.log(fd);
    console.log(file, file.name);
    let httpHeaders = new HttpHeaders({
      'authorization': 'Bearer ' + this.token,
      "authfor": "W"
    });
    httpHeaders.set('Content-type', 'multipart/form-data; boundary=1234567890xxxyyy104');
    return this.HttpClient.post(this.baseURL + endPoint, fd, { headers: httpHeaders });
  }





  getImageSRC(imageSrc: string, defaultSrc: string = ''): any {

    return this.baseURL + 'uploads/' + imageSrc ? imageSrc : defaultSrc
  }

  logout() {
    this.route.navigateByUrl("/login");
   }

   public getAPIToken = ():string => {
    return this.token;
   }

}
